/**
 * SUP-ADMIN-UI-01 — TanStack Query keys for the bug-report triage feature.
 *
 * Per `tanstack-query-conventions` — narrow, hierarchical keys so an
 * invalidation targets the smallest slice that matters. The list key carries
 * the serialised filter set so each filter combination caches independently;
 * the detail key is per-report.
 */
import type { BugReportListFilters } from "./types.js";

export const supportKeys = {
  all: ["support", "bug-reports"] as const,

  /** A filtered+paged triage list page. */
  list: (filters: BugReportListFilters) =>
    [...supportKeys.all, "list", filters] as const,

  /** One report's full detail. */
  detail: (id: string) => [...supportKeys.all, "detail", id] as const,
};
